<template>
  <div>
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <h5>Búsqueda</h5>
        <p class="lead">
          Tipo de cambio: <b> ${{ tipoDeCambio }} </b>
        </p>
      </div>

      <div class="card-body">
        <CTabs>
          <CTab title="Por póliza">
            <form @submit="handleSearch" id="busquedaForm">
              <form-builder :elements="formPoliza" class="mt-3" />
              <div class="col-12 d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-outline-info mr-1" @click="searchDownload">
                  Consultar y descargar
                </button>
                <button type="submit" class="btn btn-primary">
                  Generar lote
                </button>
              </div>
            </form>
          </CTab>
          <CTab title="Por periodo">
            <div class="mt-3">
              <FormBuilder :elements="formPeriodo" />
              <div class="col-12 d-flex justify-content-end mt-3">
                <button class="btn btn-primary">Buscar</button>
              </div>
            </div>
          </CTab>
        </CTabs>
      </div>
    </div>

    <div class="card" v-if="searchResults.length">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5>Resultados</h5>
        <div id="big-badge">
          <div class="badge badge-info mr-1">
            ID Lote: {{ loteDetails.IdLote }}
          </div>
          <div class="badge badge-info mr-1">
            Status: {{ loteDetails.StatusLote }}
          </div>
          <div class="badge badge-info">
            Total de registros: {{ loteDetails.RegistrosLote }}
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-end mb-3">
          <!-- <button class="btn btn-sm btn-outline-info">
            <i class="fas fa-file-download"></i> Descargar
          </button> -->
          <!-- <button class="btn btn-sm btn-primary ml-2" @click="modals.pago = true"> -->
          <button :disabled="pagoG" class="btn btn-sm btn-primary ml-2" @click="pagoLote(loteDetails.IdLote)">
            <i class="fas fa-credit-card"></i>
            <span class="ml-1 pr-1"> Pagar </span>
          </button>
        </div>
        <div class="table-responsive">
          <table class="table table-stripped">
            <thead class="thead-light">
              <tr>
                <th style="width: 30px">
                  <input v-model="checkTabla" type="checkbox" @click="checkAll" />
                </th>
                <th class="text-primary">Cons.</th>
                <th class="text-primary">No. Contrato</th>
                <th class="text-primary">Renov / Ramo</th>
                <th class="text-primary">Endoso</th>
                <th class="text-primary">Recibo</th>
                <th class="text-primary">Monto</th>
                <th class="text-primary">Monto DLS</th>
                <th class="text-primary">Vencimiento</th>
                <th class="text-primary">Intentos</th>
                <th class="text-primary">Sistema</th>
                <th class="text-primary">Status pago</th>
                <th class="text-primary">Status app</th>
                <th class="text-primary">Info</th>
              </tr>
            </thead>
            <tbody v-for="(result, i) in itemsResult" :key="i" class="text-right">
              <tr>
                <th>
                  <input v-bind:value="result.Folio" v-model="searchTempSelect"
                    :disabled="result.StatusPago == 'En Proceso'" type="checkbox" />
                </th>
                <td>{{ result.Folio }}</td>
                <td>{{ result.NoContrato }}</td>
                <td>{{ result.RenRamo }}</td>
                <td>{{ result.Endoso }}</td>
                <td>{{ result.Recibo }}</td>
                <td>{{ result.MontoMX }}</td>
                <td>{{ result.MontoDLS }}</td>
                <td>{{ result.Vencimiento }}</td>
                <td>{{ result.Intentos }}</td>
                <td>{{ result.Sistema }}</td>
                <td>
                  <div class="badge badge-dark" v-if="result.StatusPago == 'Sin Procesar'">
                    {{ result.StatusPago }}
                  </div>
                  <div class="badge badge-danger" v-if="result.StatusPago == 'No Exitoso'">
                    {{ result.StatusPago }}
                  </div>
                  <div class="badge badge-success" v-if="result.StatusPago == 'Exitoso'">
                    {{ result.StatusPago }}
                  </div>
                  <div class="badge badge-warning" v-if="result.StatusPago == 'Otro'">
                    {{ result.StatusPago }}
                  </div>
                  <div class="badge badge-info" v-if="result.StatusPago == 'En Proceso'">
                    {{ result.StatusPago }}
                  </div>
                </td>
                <td>
                  <div class="badge badge-info" v-if="result.StatusAplicacion == 'Pendiente'">
                    {{ result.StatusAplicacion }}
                  </div>
                  <div class="badge badge-danger" v-if="result.StatusAplicacion == 'No Aplicado'">
                    {{ result.StatusAplicacion }}
                  </div>
                  <div class="badge badge-success" v-if="result.StatusAplicacion == 'Aplicado'">
                    {{ result.StatusAplicacion }}
                  </div>
                  <div class="badge badge-warning" v-if="result.StatusAplicacion == 'Incompleto'">
                    {{ result.StatusAplicacion }}
                  </div>
                  <div class="badge badge-dark" v-if="result.StatusAplicacion == 'Sin Procesar'">
                    {{ result.StatusAplicacion }}
                  </div>
                </td>
                <td>
                  <button class="btn btn-sm btn-info" @click="handleModalDetalles(result, paginadorStart + i + 1)">
                    <i class="fas fa-address-card"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <iframe name="trastero" :src="rutaAspx" style="width:0px;height:0px;visibility:hidden"></iframe>

        <div>
          <!-- <div class="d-flex justify-content-end col-12 pr-0 pt-3">
            <button class="btn btn-sm btn-warning">
              <i class="fas fa-envelope"></i> Enviar notificaciónes
            </button>
          </div> -->
          <div class="w-100 d-flex justify-content-end paginador_container mt-3">
            <div class="btn paginador" :class="paginador.current == i + 1 ? 'btn-primary' : 'btn-light'"
              v-for="(search, i) in itemsPaginador" :key="i" @click="handlePaginador(i)">
              {{ i + 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <!-- modal detalle del resultado -->
    <CModal :show.sync="modals.detalle" :close-on-backdrop="false">
      <template #header-wrapper>
        <div class="card-header">
          <h2>Consecutivo: {{ modals.consecutivo }}</h2>
        </div>
      </template>
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0 d-flex flex-wrap">
        <div class="form-group col-6">
          <label for="">No. tarjeta</label>
          <input element="text" class="form-control" disabled :value="searchDetails.NumConvenio" />
        </div>
        <div class="form-group col-6">
          <label for="">Fecha de expiración</label>
          <input element="text" class="form-control" disabled :value="searchDetails.Valor" />
        </div>
        <div class="form-group col-6">
          <label for="">Tipo de tarjeta</label>
          <input element="text" class="form-control" disabled :value="searchDetails.TipoElemento" />
        </div>
        <div class="form-group col-6">
          <label for="">Fecha último intento</label>
          <input element="text" class="form-control" disabled :value="searchDetails.FechaUltimoIntento" />
        </div>
        <div class="form-group col-6">
          <label for="">Usuario último intento</label>
          <input element="text" class="form-control" disabled :value="searchDetails.UsuarioUltimoIntento" />
        </div>
        <div class="form-group col-6">
          <label for="">Banco</label>
          <input element="text" class="form-control" disabled :value="searchDetails.Banco" />
        </div>
        <div class="form-group col-6">
          <label for="">Moneda</label>
          <input element="text" class="form-control" disabled :value="searchDetails.Moneda" />
        </div>
      </div>

      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="modals.detalle = false" color="outline-secondary">Cerrar
        </CButton>
      </CCardFooter>
    </CModal>

    <!-- Modal boton de pago -->
    <CModal color="success" :show.sync="modals.pago" :close-on-backdrop="false">
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0">
        <embed type="text/html" :src="respuesta" width="450" height="300"/>
        <!-- <div v-if="iframeLoad"> -->
        <!-- <div >
          <div class="form-group">
            <p class="d-flex justify-content-between">
              <b>Carátula ingreso SISE</b> <span>1043221</span>
            </p>
          </div>
          <div class="form-group">
            <p class="d-flex justify-content-between">
              <b>Folio WEB</b> <span>202111019008561</span>
            </p>
          </div>
          <div class="form-group">
            <p class="d-flex justify-content-between">
              <b>Remesa daños</b> <span>1043125</span>
            </p>
          </div>
          <div class="form-group">
            <p class="d-flex justify-content-between">
              <b>Remesa personas</b> <span>1425893</span>
            </p>
          </div>
          <div class="form-group">
            <p class="d-flex justify-content-between">
              <b>Status del proceso</b> <span class="text-success">Aplicado</span>
            </p>
          </div>
        </div> -->
        <!-- <iframe v-if="!iframeLoad" :src="rutaAspx" frameborder="0"></iframe> -->
      </div>
      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="modals.pago = false" color="outline-secondary">Cerrar
        </CButton>
      </CCardFooter>
    </CModal>
    <download-excel class="d-none" :worksheet="sheet.sheet_name" :name="sheet.file_name" :data="excelToDownload">
      <span id="excelDownload">Archivo listo</span>
    </download-excel>
  </div>
</template>

<script>
import FormBuilder from "../../../componentes/form/FormBuilder.vue";
import { format, form } from "../../../assets/helpers";
import axios from 'axios';
import { axiosUrlBanRegio  } from "../../../store/actions/ModuloActions";

export default {
  components: {
    FormBuilder,
  },
  data() {
    return {
      paginador: {
        itemsToShow: 20,
        current: 1,
      },
      pagoG: false,
      checkTabla: "",
      respuesta: "",
      rutaAspx: "",
      tipoLote: false,
      iframeLoad: false,
      tipoCambio: 0,
      searchResults: [],
      searchTemp: [],
      searchTempSelect: [],
      responsePagoB: [],
      searchDetails: {
        IdPolizaConvenio: null,
        NumConvenio: null,
        TipoElemento: null,
        Valor1: null,
        Valor2: null,
        Banco: null,
        FechaUltimoIntento: null,
        UsuarioUltimoIntento: null,
        Moneda: null,
        Valor: null,
        
      },
      loteDetails: null,
      excelToDownload: [],
      sheet: {
        file_name: "File",
        sheet_name: "Sheet",
      },
      logguedUser: localStorage.getItem("userId"),
      formPoliza: [
        {
          label: "Póliza",
          element: "input",
          type: "number",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "Poliza",
        },
        {
          label: "Endoso",
          element: "input",
          type: "number",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "Endoso",
        },
        {
          label: "Recibo",
          element: "input",
          type: "number",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "Recibo",
        },
        {
          label: "Nombre filial",
          element: "input",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "NombreFilial",
        },
        {
          label: "No. Agente",
          element: "input",
          type: "number",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "IdAgente",
        },
        {
          label: "Fecha de inicio de vigencia",
          element: "date",
          type: "date",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "InicioVigencia",
        },
        {
          label: "Tipo de lote",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          onChange: (e) => this.methodChange(e),
          name: "TipoPago",
          element: "select",
          required: true,
          options: [
            {
              label: "- Seleccione",
              value: "",
              selected: true,
            },
            {
              label: "Banregio",
              value: "1",
            },
            {
              label: "Amex",
              value: "2",
              // selected: true,
            },
          ],
        },
      ],

      formPeriodo: [
        {
          label: "Desde",
          element: "input",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "poliza",
          type: "date",
        },
        {
          label: "Hasta",
          element: "input",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "poliza",
          type: "date",
        },
        {
          label: "Seguimiento consecutivo",
          element: "input",
          class: "col-lg-3 col-md-4",
          placeholder: "",
          name: "poliza",
        },
      ],

      // ModaLs
      modals: { detalle: false, pago: false, consecutivo: null },
      tempExcluidos:"",
      isChecked: false,
      checks: [],
      table: "",
    };
  },

  methods: { 
    checkAll(e) {
      this.searchTempSelect = [];
      this.table =
        e.target.parentElement.parentElement.parentElement.parentElement;
      this.checks = this.table.querySelectorAll("tbody [type='checkbox']:not([disabled])");
      this.isChecked = e.target.checked;
      this.checks.forEach((check) => (check.checked = this.isChecked));

      if (e.target.checked) {
        
        for (let e = 0; e < this.searchTemp.length; e++) {
          this.searchTempSelect.push(this.searchTemp[e].Folio)
        }
      }else {
        this.searchTempSelect = [];
      }
    },

    methodChange(e) {
      
      if(e.target.value == "2"){
        this.tipoLote = true;
      } else {
        this.tipoLote = false;
      }
    },

    async handleSearch(e) {
      e.preventDefault();
      const fakeForm = e.target;
      const built = form.build(fakeForm);
      const isValid = Object.values(built).some((item) => item);

      if (!isValid) {
        return this.$swal("Error", "Selecciona al menos un filtro", "error");
      }

      const {
        Poliza,
        Endoso,
        Recibo,
        NombreFilial,
        IdAgente,
        TipoPago,
        InicioVigencia,
        //Ramo,
        //Renovacion,
      } = form.build(fakeForm);

      const config = {
        metodo: "GENERAR_LOTE_DOM",
        data: {
          Ramo: -1,
          Poliza: Poliza || -1, //"2103701",
          Endoso: Endoso || -1,
          Recibo: Recibo || -1,
          NombreFilial: NombreFilial || -1,
          IdAgente: IdAgente || -1,
          InicioVigencia: InicioVigencia
            ? format.date(InicioVigencia, "dd/mm/aaaa")
            : -1,
          SNAnuales: 0,
          TipoPago: TipoPago || -1,
          IdUsuarioLogueado: this.logguedUser,
        },
      };
        // console.log(config);
      try {
        await this.$store.dispatch("metodoPost", config);
        const response = this.$store.getters.getRespuestaREST;
        this.pagoG = false;
        this.checkTabla = false;
        this.checks.forEach((check) => (check.checked = false));
        //LCEH I validar y evitar que mande el msj error cuando data = [] , copie validacion de la descarga
        //this.searchResults = response.data;
        if (!response.Lote) {
          return this.$swal("No se encontraron resultados(1)", "", "info");
        }
        //LCEH F
        this.IdLote
        this.searchResults = response.DetalleLote;

        this.searchTemp = response.DetalleLote;

        this.loteDetails = response.Lote ? response.Lote[0] : [];

        if (!this.searchResults.length) {
          this.$swal("No se encontraron resultados", "", "info");
        }
      } catch (error) {
        this.$swal("Hubo un problema al generar el lote", "", "warning");
      }
      this.searchTempSelect = [];
    },
    // Apis
    async getTipoCambio() {
      const config = {
        metodo: "GET_TIPO_CAMBIO",
        data: {
          IdUsuario: this.logguedUser,
        },
      };
      await this.$store.dispatch("metodoPost", config);
      this.tipoCambio = this.$store.getters.getRespuestaREST;
    },

    async handleModalDetalles({ IdLote, IdDetalleLote }, consecutivo) {
      this.modals.consecutivo = consecutivo;
      const config = {
        metodo: "DETALLES_LOTE_DOM",
        data: {
          IdLote,
          IdDetalleLote,
          IdUsuario: this.logguedUser,
        },
      };

      await this.$store.dispatch("metodoPost", config);
      const detalles = this.$store.getters.getRespuestaREST;
      if (!detalles.length) {
        return this.$swal("Error", "No se encontró información");
      }
      this.modals.detalle = true;
      this.searchDetails = detalles[0];
    },

    async pagoLote(idLote,e) {
      // this.iframeLoad = false;
      // this.modals.pago = true;
      let sendIdPolizas = [];
      this.pagoG = true;
      for (let i = 0; i < this.searchTemp.length; i++) {
        sendIdPolizas.push(this.searchTemp[i].Folio)
      }

      for (let e = 0; e < this.searchTempSelect.length; e++) {
        let foundid = sendIdPolizas.indexOf(this.searchTempSelect[e]);
        if (foundid !== -1) {
          sendIdPolizas.splice(foundid, 1);
        }
      }

      let foliosEx = "";
      for (let i = 0; i < sendIdPolizas.length; i++) {
        if (i == sendIdPolizas.length - 1) {
          foliosEx += sendIdPolizas[i].toString();
        } else {
          foliosEx += sendIdPolizas[i].toString() + ",";
        }
      }

      this.tempExcluidos = foliosEx;
      if(foliosEx == "" || this.searchTemp.length === this.searchTempSelect.length) {
        this.tempExcluidos = -1
      }else {
        this.tempExcluidos = foliosEx.toString();
      }
      this.rutaAspx = `${axiosUrlBanRegio()}?valor=${idLote}&valor2=${this.tempExcluidos}&valor3=${this.logguedUser}`;
      // console.log(`${axiosUrlBanRegio()}?valor=${idLote}&valor2=${this.tempExcluidos}&valor3=${this.logguedUser}`);
      // console.log(this.tempExcluidos);
    },
    foliosExcluidos() {

      let sendIdPolizas = [];
      for (let i = 0; i < this.searchTemp.length; i++) {
        sendIdPolizas.push(this.searchTemp[i].Folio)
      }
      for (let e = 0; e < this.searchTempSelect.length; e++) {
        let foundid = sendIdPolizas.indexOf(this.searchTempSelect[e]);
        if (foundid !== -1) {
          sendIdPolizas.splice(foundid, 1);
        }
      }
      let foliosEx = "";


      for (let i = 0; i < sendIdPolizas.length; i++) {
        if (i == sendIdPolizas.length - 1) {

          foliosEx += sendIdPolizas[i].toString();
        } else {
          foliosEx += sendIdPolizas[i].toString() + ",";
        }

      }
    },

    async searchDownload() {
      const fakeForm = document.querySelector("#busquedaForm");
      const built = form.build(fakeForm);
      const isValid = Object.values(built).some((item) => item);

      if (!isValid) {
        return this.$swal("Error", "Selecciona al menos un filtro", "error");
      }

      const {
        Poliza,
        Endoso,
        Recibo,
        NombreFilial,
        IdAgente,
        TipoPago,
        InicioVigencia,
        //Ramo,
        //Renovacion,
      } = form.build(fakeForm);

      const config = {
        metodo: "GENERAR_DESCARGAR_LOTE_DOM",
        data: {
          Ramo: "-1",
          Poliza: Poliza || "-1", //"2103701",
          Endoso: Endoso || "-1",
          Recibo: Recibo || "-1",
          NombreFilial: NombreFilial || "-1",
          IdAgente: IdAgente || "-1",
          //IdPromotor: "-1",
          InicioVigencia: InicioVigencia
            ? format.date(InicioVigencia, "dd/mm/aaaa")
            : "-1",
          SNAnuales: 0,
          TipoPago: TipoPago || "-1",
          IdUsuarioLogueado: this.logguedUser,
          //Ramo,
          //Renovacion,
          //TipoRecibo: "1",
        },
      };
      console.log(config);
      try {
        await this.$store.dispatch("metodoPost", config);
        const response = this.$store.getters.getRespuestaREST;
        
        const promise = new Promise((resolve, _) => {
          resolve(this.excelToDownload = response.data);
        });

        promise.then(_ => {
          if (!this.excelToDownload) {
          return this.$swal("No se encontraron resultados", "", "info");
          }
          this.sheet.file_name = response.generales[0].file_name;
          this.sheet.sheet_name = response.generales[0].sheet_name;

          document.querySelector("#excelDownload").click()

        });
      } 
      catch (error) {
        this.$swal("Hubo un error al descargar el archivo", "", "warning");
      }

    },

    handlePaginador(to) {
      this.paginador.current = to + 1;
    },
  },

  computed: {
    tipoDeCambio() {
      return format.money(this.tipoCambio);
    },

    itemsPaginador() {
      return Math.ceil(this.searchResults.length / this.paginador.itemsToShow);
    },

    paginadorEnd() {
      return this.paginador.current * this.paginador.itemsToShow;
    },
    paginadorStart() {
      return this.paginador.current == 1
        ? 0
        : this.paginadorEnd - this.paginador.itemsToShow;
    },

    itemsResult() {
      return this.searchResults.slice(this.paginadorStart, this.paginadorEnd);
    },
  },
  mounted() {
    this.getTipoCambio();
  },
};
</script>

<style lang="scss">
#big-badge>.badge {
  font-size: 16px !important;
  border-radius: 20px !important;
  padding-left: 10px;
  padding-right: 10px;
}

.paginador_container {
  .btn {
    border-radius: 0px !important;
    border: 1px solid rgba(0, 61, 114, 0.651);
    border-right: 0px solid rgba(0, 61, 114, 0.651);
    padding: 5px 10px !important;

    &:first-child {
      border-radius: 5px 0 0 5px !important;
    }

    &:last-child {
      border: 1px solid rgba(0, 61, 114, 0.651);
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
    }
  }
}
</style>